import type { PerformanceTimeseriesBucket } from "src/store/api/generatedApi";

export type DatasetSplit = "train" | "val" | "test";

const SPLIT_LABEL_KEYS: Record<DatasetSplit, string> = {
  train: "datasetSplitTrain",
  val: "datasetSplitValidation",
  test: "datasetSplitTest",
};

export const splitLabelKey = (split: DatasetSplit): string =>
  SPLIT_LABEL_KEYS[split];

export type SplitPeriod = Readonly<{
  start: string;
  end: string;
  split: string;
}>;

export const filterBucketsBySplit = (
  buckets: readonly PerformanceTimeseriesBucket[],
  splitPeriods: readonly SplitPeriod[],
  selectedSplits: readonly string[]
): readonly PerformanceTimeseriesBucket[] => {
  if (selectedSplits.length === 0 || splitPeriods.length === 0) {
    return buckets;
  }

  const matchingPeriods = splitPeriods.filter((p) =>
    selectedSplits.includes(p.split)
  );

  if (matchingPeriods.length === 0) {
    return [];
  }

  return buckets.filter((bucket) => {
    const bucketStart = new Date(bucket.bucket_start).getTime();
    return matchingPeriods.some((period) => {
      const periodStart = new Date(period.start).getTime();
      const periodEnd = new Date(period.end).getTime();
      return bucketStart >= periodStart && bucketStart < periodEnd;
    });
  });
};
